/**
 * Faven Landing Page JavaScript
 * Handles all interactive functionality for the Faven landing page
 */

// Alpine.js Global App Data
document.addEventListener('alpine:init', () => {
  Alpine.store('favenApp', {
    // Global state
    mobileMenuOpen: false,
    showFloatingCTA: false,
    
    // Notification system
    notification: {
      show: false,
      message: '',
      type: 'success'
    },
    
    // Initialize app
    init() {
      this.initFloatingCTA();
      this.initAnimations();
      this.enhanceSliders();
    },
    
    
    // Mobile menu methods
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    
    // Floating CTA functionality
    initFloatingCTA() {
      let heroSection = document.getElementById('hero');
      if (!heroSection) return;
      
      window.addEventListener('scroll', () => {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollY = window.scrollY;
        const leadForm = document.getElementById('lead-form');
        
        // Show floating CTA when scrolled past hero but before lead form
        if (scrollY > heroBottom && leadForm && scrollY < leadForm.offsetTop - 200) {
          this.showFloatingCTA = true;
        } else {
          this.showFloatingCTA = false;
        }
      });
    },
    
    // Notification system
    showNotification(message, type = 'success') {
      this.notification = {
        show: true,
        message: message,
        type: type
      };
      
      // Auto hide after 5 seconds
      setTimeout(() => {
        this.hideNotification();
      }, 5000);
    },
    
    hideNotification() {
      this.notification.show = false;
    },
    
    // Initialize scroll animations
    initAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, observerOptions);
      
      // Observe elements for animation
      const animatedElements = document.querySelectorAll('.hover-scale, .bg-faven-gray');
      animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
      });
    },
    
    // Enhance range sliders with dynamic backgrounds
    enhanceSliders() {
      const sliders = document.querySelectorAll('input[type="range"]');
      
      sliders.forEach(slider => {
        // Add dynamic class for JavaScript-controlled styling
        slider.classList.add('range-slider-dynamic');
        
        const updateSliderBackground = () => {
          const value = slider.value;
          const min = slider.min;
          const max = slider.max;
          const percentage = (value - min) / (max - min) * 100;
          
          slider.style.background = `linear-gradient(to right, #a8f63e 0%, #a8f63e ${percentage}%, #4a5568 ${percentage}%, #4a5568 100%)`;
        };
        
        updateSliderBackground();
        slider.addEventListener('input', updateSliderBackground);
      });
    },
    
    // Update slider backgrounds
    updateSliderBackgrounds() {
      const sliders = document.querySelectorAll('input[type="range"]');
      
      sliders.forEach(slider => {
        const value = slider.value;
        const min = slider.min;
        const max = slider.max;
        const percentage = (value - min) / (max - min) * 100;
        
        slider.style.background = `linear-gradient(to right, #a8f63e 0%, #a8f63e ${percentage}%, #4a5568 ${percentage}%, #4a5568 100%)`;
      });
    }
  });
});

let activeSmoothScrollFrame = null;

function smoothScrollToTarget(target, offset = 80) {
  if (!target) return;

  if (activeSmoothScrollFrame !== null) {
    cancelAnimationFrame(activeSmoothScrollFrame);
  }

  const currentScroll = window.pageYOffset;
  const targetTop = target.getBoundingClientRect().top + currentScroll;
  const targetPosition = Math.max(0, targetTop - offset);
  const scrollDistance = targetPosition - currentScroll;
  const duration = Math.min(500 + Math.abs(scrollDistance) * 0.5, 1200);
  let startTime = null;

  function scrollAnimation(currentTime) {
    if (startTime === null) startTime = currentTime;

    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easeInOutQuad = progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;

    window.scrollTo(0, currentScroll + (scrollDistance * easeInOutQuad));

    if (progress < 1) {
      activeSmoothScrollFrame = requestAnimationFrame(scrollAnimation);
      return;
    }

    window.scrollTo(0, targetPosition);
    activeSmoothScrollFrame = null;
  }

  activeSmoothScrollFrame = requestAnimationFrame(scrollAnimation);
}

// Initialize smooth scrolling immediately - don't wait for Alpine
(function() {
  'use strict';
  
  // Use capture phase to intercept clicks before other handlers
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || href === '#' || href.includes('icon-')) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    
    smoothScrollToTarget(target);
  }, true); // Use capture phase
})();

function initStarterPackInteractiveFilters() {
  const filterButtons = Array.from(document.querySelectorAll('[data-starter-filter-button]'));
  const resultsSection = document.querySelector('[data-starter-pack-results]');

  if (!filterButtons.length || !resultsSection) return;

  const filterAccentClasses = {
    green: {
      border: 'border-faven-green',
      background: 'bg-faven-green/10',
      confirmationBackground: 'bg-faven-green/25',
      ring: 'ring-faven-green/45'
    },
    purple: {
      border: 'border-faven-purple',
      background: 'bg-faven-purple/10',
      confirmationBackground: 'bg-faven-purple/25',
      ring: 'ring-faven-purple/45'
    },
    red: {
      border: 'border-faven-red',
      background: 'bg-faven-red/10',
      confirmationBackground: 'bg-faven-red/25',
      ring: 'ring-faven-red/45'
    }
  };
  const activeFilterClasses = ['ring-1', ...Object.values(filterAccentClasses).flatMap(({ border, background, ring }) => [border, background, ring])];
  const getFilterAccentClasses = (button) => filterAccentClasses[button.dataset.starterFilterAccent] || filterAccentClasses.green;
  const state = { size: '', family: '' };
  const productCards = Array.from(resultsSection.querySelectorAll('[data-starter-product]'));
  const familyGroups = Array.from(resultsSection.querySelectorAll('[data-starter-family-group]'));
  const collectionList = resultsSection.querySelector('[data-starter-collection-list]');
  const resultsContent = resultsSection.querySelector('[data-starter-results-content]');
  const resetButtons = Array.from(resultsSection.querySelectorAll('[data-starter-filter-reset]'));
  const emptyState = resultsSection.querySelector('[data-starter-empty]');
  const selectionMessage = resultsSection.querySelector('[data-starter-selection-message]');
  const selectionProduct = resultsSection.querySelector('[data-starter-selection-product]');
  const selectionProductName = resultsSection.querySelector('[data-starter-selection-product-name]');
  const selectionProductLink = resultsSection.querySelector('[data-starter-selection-product-link]');
  const filterSelects = {
    size: resultsSection.querySelector('[data-starter-filter-select="size"]'),
    family: resultsSection.querySelector('[data-starter-filter-select="family"]')
  };
  let pendingFilterScroll = null;

  function clearPendingFilterScroll() {
    if (!pendingFilterScroll) return;

    window.clearTimeout(pendingFilterScroll.timeoutId);
    pendingFilterScroll.button.classList.remove(
      pendingFilterScroll.confirmationBackground,
      'scale-[1.01]'
    );
    pendingFilterScroll = null;
  }

  function populateFilterSelects() {
    ['size', 'family'].forEach((type) => {
      const select = filterSelects[type];
      if (!select) return;

      filterButtons
        .filter((button) => button.dataset.starterFilterType === type)
        .forEach((button) => {
          if (select.querySelector(`option[value="${button.dataset.starterFilterValue}"]`)) return;

          const option = document.createElement('option');
          option.value = button.dataset.starterFilterValue;
          option.textContent = button.dataset.starterFilterLabel;
          select.append(option);
        });
    });
  }

  function updateResults() {
    filterButtons.forEach((button) => {
      const type = button.dataset.starterFilterType;
      const isActive = state[type] === button.dataset.starterFilterValue;
      const accentClasses = getFilterAccentClasses(button);

      button.setAttribute('aria-pressed', String(isActive));
      button.classList.remove(...activeFilterClasses);
      if (isActive) button.classList.add(accentClasses.border, accentClasses.background, 'ring-1', accentClasses.ring);
    });

    productCards.forEach((card) => {
      const matchesSize = !state.size || card.dataset.starterSize === state.size;
      const matchesFamily = !state.family || card.dataset.starterFamily === state.family;
      card.classList.toggle('hidden', !(matchesSize && matchesFamily));
    });

    familyGroups.forEach((group) => {
      const hasVisibleProducts = Array.from(group.querySelectorAll('[data-starter-product]')).some((card) => !card.classList.contains('hidden'));
      group.classList.toggle('hidden', !hasVisibleProducts);
    });

    if (emptyState) {
      emptyState.classList.toggle('hidden', productCards.some((card) => !card.classList.contains('hidden')));
    }

    if (selectionMessage) {
      const hasCompleteSelection = Boolean(state.size && state.family);
      const selectedProductCard = productCards.find((card) => !card.classList.contains('hidden'));
      const selectedProductTitleLink = selectedProductCard?.querySelector('.product-card__title a');

      selectionMessage.classList.toggle('hidden', !hasCompleteSelection);
      selectionMessage.classList.toggle('flex', hasCompleteSelection);

      if (selectionProduct) selectionProduct.classList.toggle('hidden', !selectedProductTitleLink);
      if (selectedProductTitleLink) {
        if (selectionProductName) selectionProductName.textContent = selectedProductTitleLink.textContent.trim();
        if (selectionProductLink) selectionProductLink.href = selectedProductTitleLink.href;
      }
    }

    if (collectionList) {
      collectionList.classList.toggle('starter-collection-list--size-only', Boolean(state.size && !state.family));
    }

    if (resultsContent) {
      resultsContent.classList.toggle('starter-results-content--complete-selection', Boolean(state.size && state.family));
    }

    ['size', 'family'].forEach((type) => {
      if (filterSelects[type]) filterSelects[type].value = state[type];
    });
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const type = button.dataset.starterFilterType;
      const value = button.dataset.starterFilterValue;
      state[type] = state[type] === value ? '' : value;
      updateResults();
      clearPendingFilterScroll();

      const nextTarget = button.closest('[data-starter-filter-next]')?.dataset.starterFilterNext;
      if (state[type] && nextTarget) {
        const { confirmationBackground } = getFilterAccentClasses(button);
        button.classList.add(confirmationBackground, 'scale-[1.01]');

        const timeoutId = window.setTimeout(() => {
          button.classList.remove(confirmationBackground, 'scale-[1.01]');
          pendingFilterScroll = null;
          const target = document.querySelector(nextTarget);
          smoothScrollToTarget(target, 96);
        }, 420);

        pendingFilterScroll = { timeoutId, button, confirmationBackground };
      }
    });
  });

  Object.entries(filterSelects).forEach(([type, select]) => {
    if (!select) return;

    select.addEventListener('change', () => {
      state[type] = select.value;
      updateResults();
    });
  });

  resetButtons.forEach((resetButton) => {
    resetButton.addEventListener('click', () => {
      state.size = '';
      state.family = '';
      updateResults();
    });
  });

  populateFilterSelects();
  updateResults();
}

// Initialize app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Alpine !== 'undefined' && Alpine.store) {
    // Ensure the favenApp store exists before calling init
    const favenStore = Alpine.store('favenApp');
    if (favenStore && typeof favenStore.init === 'function') {
      favenStore.init();
    }
  }

  initStarterPackInteractiveFilters();
});

// Custom CSS for enhanced styling (minimal - most styles now in Tailwind)
const favenStyles = document.createElement('style');
favenStyles.textContent = `
  /* Dynamic range slider background updates - requires JavaScript */
  .range-slider-dynamic {
    -webkit-appearance: none;
    appearance: none;
    height: 8px;
    border-radius: 4px;
    outline: none;
    background: linear-gradient(to right, #a8f63e 0%, #a8f63e 30%, #4a5568 30%, #4a5568 100%);
  }
`;

document.head.appendChild(favenStyles);
